import styled from "styled-components";
import theme from "../../theme/theme";
import BackgroundImage from "../../assets/login-bg.jpg";

export const MainDiv = styled.div`
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 50%,
      white 50%,
      white 100%
    ),
    url(${BackgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 10px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.color.silver};
  border-radius: 30px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  color: ${theme.color.black};
  background-color: ${theme.color.white};
  width: 40%;
  margin: 50px auto;
  justify-content: center;
  align-items: center;
  padding: 10px;

  @media (max-width: 900px) {
    width: 70%;
  }

  @media (max-width: 640px) {
    width: 90%;
  }
`;

export const LogoImage = styled.img`
  width: 20%;
  height: auto;
  margin: 15px auto 5px;

  @media (max-width: 640px) {
    width: 35%;
  }
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 20px auto;
`;

export const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${theme.color.space};
  font-size: 1.2rem;
  background-color: ${theme.color.white};
  color: ${theme.color.stone};
  margin: 20px 0;
  flex-grow: 1;
  outline: none; /* Remueve el contorno en el foco */
  &:focus {
    border-bottom-color: ${theme.color.space};
    color: ${theme.color.black};
  }
  &:valid {
    color: ${theme.color.black};
  }
`;

export const Button = styled.button`
  background-color: ${theme.color.navy};
  color: ${theme.color.white};
  padding: 8px;
  border-radius: 8px;
  font-size: 1.2rem;
  border: none;
  margin: 20px 0;

  &:hover {
    cursor: pointer;
  }
`;
export const Header1 = styled.h1`
  width: 90%;
  color: ${theme.color.navy};
  font-size: 3rem;
  margin: 35px 0 0 20px;
  font-family: "Inter", sans-serif;

  @media (max-width: 480px) {
    font-size: 2.2rem;
  }
`;

export const List = styled.ul`
  margin-top: 0;
`;

export const BulletPoints = styled.li`
  width: 90%;
  margin: 0 auto;
  color: ${theme.color.black};
  font-size: 1rem;
  font-weight: 400;
`;

export const Anchor = styled.a`
  text-decoration: none;
  font-weight: 600;
  color: ${theme.color.navy};
  &:hover {
    cursor: pointer;
    color: ${theme.color.denim};
  }
`;

export const Message = styled.p`
  color: ${theme.color.black};
  margin-bottom: 15px;
`;

export const LoginMessage = styled.p`
  color: ${theme.color.stone};
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1rem;
  align-self: center;
  margin-top: 30px;
`;

export const IconContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
`;

export const ButtonIcon = styled.button`
  background-color: ${theme.color.white};
  border: none;
  position: absolute;
  right: 0;

  &:hover {
    cursor: pointer;
  }
`;

export const CheklistWrapper = styled.div`
  margin-left: 24px;
`;